(function() { window.GUID_a4d351f6_060c_4afa_af0d_3df32650e29b = { getGuid: function() { return "a4d351f6-060c-4afa-af0d-3df32650e29b"; } }; })();
var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["Enter"] = 13] = "Enter";
    KeyCode[KeyCode["Escape"] = 27] = "Escape";
    KeyCode[KeyCode["SpaceBar"] = 32] = "SpaceBar";
    KeyCode[KeyCode["ArrowUp"] = 38] = "ArrowUp";
    KeyCode[KeyCode["ArrowDown"] = 40] = "ArrowDown";
    KeyCode[KeyCode["ArrowLeft"] = 37] = "ArrowLeft";
    KeyCode[KeyCode["ArrowRight"] = 39] = "ArrowRight";
    KeyCode[KeyCode["Add"] = 107] = "Add";
    KeyCode[KeyCode["Plus"] = 107] = "Plus";
    KeyCode[KeyCode["Subtract"] = 109] = "Subtract";
    KeyCode[KeyCode["Minus"] = 109] = "Minus";
})(KeyCode || (KeyCode = {}));

//# sourceMappingURL=KeycodeEnum.js.map
